(function(){
  var a = document.querySelector(".qr");
  if (!a) return;
  var D = "/rfqJD/BYV9z0G6uwPrLt062GNXbqVVGUuwQMy8BB/qqqqr+ANB1kACfv/ocy5DQTs+EgPyIfpKAuUlA9btmaZ2CCIt/h9VULJIT/7MzPCI0vUszEnhBgH5NK+Sq/mXn5riavl15fLK549NkTPHN2VCJx7fYUbvopTvwDsqzOvXGP2XvfdHtVyV7OxiyMC/otFgeGE0icjSqY0tsR1Vr+t9wgkb3M1Ad+oBPm8nEv6565OvQWMnWkbusb1AfjdZKTviW6WLhVWME2oQEVf6VAXHsAA==";
  var n = 41, bin = atob(D), bits = "", i, j, d = "";
  for (i = 0; i < bin.length; i++) {
    var v = bin.charCodeAt(i).toString(2);
    bits += ("00000000" + v).slice(-8);
  }
  for (i = 0; i < n; i++) for (j = 0; j < n; j++) {
    if (bits[i * n + j] === "1") d += "M" + j + " " + i + "h1v1h-1z";
  }
  var img = a.querySelector("img");
  if (img) img.remove();
  a.insertAdjacentHTML("beforeend", '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" shape-rendering="crispEdges" role="img" aria-label="QR code vers le WhatsApp du cabinet Dr Jerrar"><rect width="41" height="41" fill="#fff"/><path fill="#2A3A34" d="' + d + '"/></svg>');
})();
